import { render, staticRenderFns } from "./HistoricoAditamentoItem.vue?vue&type=template&id=127f0229&scoped=true"
import script from "./HistoricoAditamentoItem.vue?vue&type=script&lang=js"
export * from "./HistoricoAditamentoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127f0229",
  null
  
)

export default component.exports